import { useTimezoneStore } from 'src/store/timezoneStore';

interface TableHeaderProps {
  id: string;
  label: string;
  align?: 'left' | 'center' | 'right';
}

export const useTableColumns = () => {
  const { timezone } = useTimezoneStore();

  const puzzleItemsColumns: TableHeaderProps[] = [
    { id: 'id', label: 'ID', align: 'center' },
    { id: 'languageCode', label: 'Code', align: 'center' },
    { id: 'name', label: 'Name' },
    { id: 'categoryId', label: 'Category ID', align: 'center' },
    { id: 'createdAt', label: `Created At (${timezone})`, align: 'center' },
    { id: 'actions', label: 'Actions', align: 'right' },
  ];

  const categoriesColumns: TableHeaderProps[] = [
    { id: 'id', label: 'ID' },
    { id: 'languageCode', label: 'Code' },
    { id: 'name', label: 'Name' },
    { id: 'difficulty', label: 'Difficulty' },
    { id: 'explanation', label: 'Explanation' },
    { id: 'createdAt', label: `Created At (${timezone})` },
    { id: 'actions', label: 'Actions', align: 'center' },
  ];

  const gamesColumns: TableHeaderProps[] = [
    { id: 'id', label: 'ID' },
    { id: 'languageCode', label: 'Game Code' },
    { id: 'title', label: 'Title' },
    { id: 'startTime', label: `Start Time (${timezone})` },
    { id: 'endTime', label: `End Time (${timezone})` },
    { id: 'status', label: 'Status' },
    { id: 'categoryIds', label: 'Categories' },
    { id: 'createdAt', label: `Created At (${timezone})` },
    { id: 'actions', label: 'Actions' },
  ];

  return { puzzleItemsColumns, categoriesColumns, gamesColumns };
};
